import { UseQueryResult, useQuery } from 'react-query';

import { GetEquipmentProfile } from '@pimm/services/lib/sms-tenants/services';
import { GetEquipmentProfileQueryParams } from '@pimm/services/lib/sms-tenants';

export const useGetEquipmentProfile = (
  query?: GetEquipmentProfileQueryParams,
  queryKey?: string,
): UseQueryResult<Awaited<ReturnType<typeof GetEquipmentProfile>>> => {
  const queryEquipmentProfile = useQuery({
    enabled: !!query?.siteId,
    queryKey: [queryKey ?? 'GetEquipmentProfile', query],
    queryFn: () => GetEquipmentProfile(query),
  });
  return queryEquipmentProfile;
};
